import appApi from '@/api/appApi'

const SET_APP_INFO_LIST = 'setAppInfoList'
const SET_APP_INFO_COUNT = 'setAppInfoCount'
const SET_BIN_INFO_LIST = 'setBinInfoList'
const SET_BIN_INFO_COUNT = 'setBinInfoCount'

const state = {
  appInfoList: [],
  appInfoCount: 0,

  binInfoList: [],
  binInfoCount: 0
}

const mutations = {
  [SET_APP_INFO_LIST] (state, appInfoList) {
    state.appInfoList = appInfoList
  },
  [SET_APP_INFO_COUNT] (state, appInfoCount) {
    state.appInfoCount = appInfoCount
  },
  [SET_BIN_INFO_LIST] (state, binInfoList) {
    state.binInfoList = binInfoList
  },
  [SET_BIN_INFO_COUNT] (state, binInfoCount) {
    state.binInfoCount = binInfoCount
  }
}

const actions = {
  async getAppInfos ({ commit }, data) {
    try {
      const res = await appApi.getAppInfos(data.page, data.pageSize, data.sort, data.filters)

      if (res && res.rcode === 0) {
        commit(SET_APP_INFO_LIST, res.data.app_infos)
        commit(SET_APP_INFO_COUNT, res.data.count)
      }
      return res
    } catch (err) {
      return err
    }
  },
  async addAppInfo ({ commit }, data) {
    try {
      return await appApi.addAppInfo(data.appName, data.remarks, data.type)
    } catch (err) {
      return err
    }
  },
  async getBinInfos ({ commit }, data) {
    try {
      const res = await appApi.getBinInfos(data.page, data.pageSize, data.sort, data.filters)

      if (res && res.rcode === 0) {
        commit(SET_BIN_INFO_LIST, res.data.bin_infos)
        commit(SET_BIN_INFO_COUNT, res.data.count)
      }
      return res
    } catch (err) {
      return err
    }
  },
  async addBinInfo ({ commit }, data) {
    try {
      return await appApi.addBinInfo(data)
    } catch (err) {
      return err
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js